import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useDispatch } from "react-redux";
import {
  createNotificationService,
  getNotificationsInfoService,
} from "redux/services/general_service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const NotificationModal = ({ isOpen, onClose, notification }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    translations: {
      en: { title: "", text: "" },
      ar: { title: "", text: "" },
    },
    image: null, // إضافة حقل للصورة
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (notification) {
      setFormData({
        translations: notification?.translations || {
          en: { title: "", text: "" },
          ar: { title: "", text: "" },
        },
        image: notification?.image || null, // إضافة الصورة إذا كانت موجودة
      });
    } else {
      setFormData({
        translations: {
          en: { title: "", text: "" },
          ar: { title: "", text: "" },
        },
        image: null,
      });
    }
    setErrors({});
  }, [notification, isOpen]);

  const handleInputChange = (lang, field, value) => {
    setFormData((prev) => ({
      ...prev,
      translations: {
        ...prev.translations,
        [lang]: {
          ...prev.translations[lang],
          [field]: value,
        },
      },
    }));
    if (errors?.[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.translations.ar.title.trim()) {
      newErrors.titleAr = t("arabicTitleRequired");
    }
    if (!formData.translations.ar.text.trim()) {
      newErrors.textAr = t("arabicTextRequired");
    }
    // يمكن إضافة تحقق للصورة إذا كانت مطلوبة، لكنها اختيارية هنا
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSave = () => {
  if (!validateForm()) return;

  try {
    const dataToSend = new FormData();

    // إلحاق حقول الترجمات بشكل منفصل
    dataToSend.append("translations[ar][title]", formData.translations.ar.title);
    dataToSend.append("translations[ar][text]", formData.translations.ar.text);
    dataToSend.append("translations[en][title]", formData.translations.en.title);
    dataToSend.append("translations[en][text]", formData.translations.en.text);

    // إلحاق الصورة إذا كانت موجودة
    if (formData.image) {
      dataToSend.append("image", formData.image);
    }

    dispatch(createNotificationService(dataToSend)).then((response) => {
      if (
        response?.payload?.status === 200 ||
        response?.payload?.status === 201
      ) {
        toast(t("تم إرسال الإشعار بنجاح "));
        dispatch(getNotificationsInfoService({ page: 1 })); // Corrected to match import
        onClose();
      }
    });
  } catch (error) {
    console.error("Error saving notification:", error);
  }
};

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999999] p-4 backdrop-blur-sm">
      {" "}
      {/* Increased z-index to 99999 */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              {notification
                ? t("editNotification")
                : t("createNewNotification")}
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {t("enterNotificationDetails")}
            </p>
          </div>
          <button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="space-y-6">
            {/* English Section 
            <div>
              <h3 className="text-md font-medium text-gray-700 dark:text-gray-300 mb-4">
                {t("english")}
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    {t("title")}
                  </label>
                  <input
                    type="text"
                    value={formData.translations.en.title}
                    onChange={(e) =>
                      handleInputChange("en", "title", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder={t("enterEnglishTitle")}
                  />
                  {errors.titleEn && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.titleEn}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    {t("text")}
                  </label>
                  <textarea
                    value={formData.translations.en.text}
                    onChange={(e) =>
                      handleInputChange("en", "text", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder={t("enterEnglishText")}
                    rows={4}
                  />
                  {errors.textEn && (
                    <p className="text-sm text-red-600 mt-1">{errors.textEn}</p>
                  )}
                </div>
              </div>
            </div>*/}

            {/* Arabic Section */}
            <div>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    {t("title")}
                  </label>
                  <input
                    type="text"
                    value={formData.translations.ar.title}
                    onChange={(e) => {
                      handleInputChange("ar", "title", e.target.value);
                      handleInputChange("en", "title", e.target.value);
                    }}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder={t("enterArabicTitle")}
                  />
                  {errors.titleAr && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.titleAr}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    {t("text")}
                  </label>
                  <textarea
                    value={formData.translations.ar.text}
                    onChange={(e) => {
                      handleInputChange("ar", "text", e.target.value);
                      handleInputChange("en", "text", e.target.value);
                    }}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder={t("enterArabicText")}
                    rows={4}
                  />
                  {errors.textAr && (
                    <p className="text-sm text-red-600 mt-1">{errors.textAr}</p>
                  )}
                </div>
                {/* إضافة حقل للصورة */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    {t("image")} (اختياري)
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  {formData.image && (
                    <p className="text-sm text-gray-600 mt-1">
                      الملف المختار: {formData.image.name}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between p-6 border-t border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-2">
            <button className="mr-4 ml-4" variant="ghost" onClick={onClose}>
              {t("cancel")}
            </button>
            <Button onClick={handleSave}>
              {notification ? t("updateNotification") : t("sendNotification")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;